import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import classNames from "classnames";
import Tooltip from "@mui/material/Tooltip";
import { ComponentStyles, mediaBreakpointDown, sizes } from 'conversional-theme';
import { JourneysSelectors, useAppSelector } from "conversional-journey";
import { ICONS } from '../icons/IconList';
import Icon from '../icons/Icon';
function IconButton(props) {
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var icon = ICONS.close;
    if (props.icon) {
        if (typeof props.icon === 'string')
            icon = ICONS[props.icon];
        else
            icon = props.icon;
    }
    var color = props.color || theme.colors.light;
    var hoverColor = props.hoverColor || theme.colors.text;
    var backgroundColor = props.backgroundColor || theme.colors.backgroundDark;
    var backgroundHoverColor = props.backgroundHoverColor || theme.colors.menuElement;
    return (_jsx(Tooltip, { title: props.tooltip || null, placement: "top", children: _jsx("div", { className: classNames('journey-close-button', css(Styles(backgroundColor, backgroundHoverColor, hoverColor).close, props.styles && ComponentStyles(props.styles)), props.className), onClick: props.close, children: _jsx(Icon, { className: props.iconClassName, hoverColor: hoverColor, icon: icon, size: '24px', color: color }) }) }));
}
var Styles = function (backgroundColor, backgroundHoverColor, hoverColor) {
    var _a;
    return StyleSheet.create({
        close: (_a = {
                transition: 'background-color 200ms',
                borderRadius: '50%',
                backgroundColor: backgroundColor,
                cursor: 'pointer',
                width: '50px',
                height: '50px',
                color: '#fff',
                display: 'flex',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center'
            },
            _a[mediaBreakpointDown(sizes.md)] = {
                width: 24,
                height: 24,
            },
            _a[':hover'] = {
                backgroundColor: backgroundHoverColor,
            },
            _a[':hover path'] = {
                fill: hoverColor,
            },
            _a),
    });
};
export default IconButton;
